import {
  ConnectorType,
  IConnector,
  PaytacaConnector,
  WalletConnect2Connector,
} from "./BchConnectorTypes";
import {
  decodeCashAddress,
  encodeCashAddress,
  CashAddressNetworkPrefix,
} from "@bitauth/libauth";

export class BchConnectorService {
  private connecting: boolean = false;
  connector?: IConnector;
  connectorType?: ConnectorType;

  constructor() {
    const type = localStorage.getItem("Connector");
    if (type) {
      this.setConnector(type as any);
    }
  }

  setConnector(connectorType: ConnectorType) {
    if (this.connectorType === connectorType) {
      return;
    }

    this.connectorType = connectorType;

    if (this.connector) {
      this.connector.disconnect();
      this.connector = undefined;
      this.connectorType = undefined;
    }

    if (connectorType === "Paytaca") {
      this.connector = new PaytacaConnector();
    } else if (connectorType === "WalletConnectV2") {
      this.connector = new WalletConnect2Connector();
    }
    localStorage.setItem("Connector", connectorType as any);
  }

  async disconnect() {
    if (this.connector) {
      this.connector.disconnect();
      this.connector = undefined;
      this.connectorType = undefined;
      localStorage.removeItem("Connector");
    }
  }

  handleErrorMessage = (error: any) => {
    return error.message ?? error;
  };

  sendConnectionRequest = async () => {
    try {
      if (this.connecting) {
        return;
      }

      this.connecting = true;
      await this.connector!.ready();

      if (!(await this.connector!.connected())) {
        await this.connector!.connect();
      }

      const reset = () => {
        localStorage.removeItem("Connector");
        localStorage.removeItem("spicaToken");
        localStorage.removeItem("spicaUserId");
        window.location.reload();
      };

      this.connector!.on("disconnect", reset);
      this.connector!.on("addressChanged", reset);
      this.connecting = false;
    } catch (error) {
      console.log("missing provider", error);
      return;
    }

    let cashaddr = await this.connector!.address();
    const isDevelopmentMode =
      process.env.REACT_APP_WEBGL_RESOURCE_KEY !== "Prod";
    const decoded = decodeCashAddress(cashaddr!);
    if (typeof decoded === "string") {
      throw Error(decoded);
    }

    cashaddr = encodeCashAddress(
      isDevelopmentMode
        ? CashAddressNetworkPrefix.testnet
        : CashAddressNetworkPrefix.mainnet,
      decoded.type,
      decoded.payload
    );

    return cashaddr;
  };
}

export default new BchConnectorService();
